/**
 * TanStack Query Hook for Tenant Signature Operations
 *
 * This module provides hooks for sending tenant signatures
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sendTenantSignature } from "../api/tenants";
import { toast } from "../utils/toast";
import { queryKeys } from "./queryKeys";

/**
 * Send tenant signature
 * Invalidates: tenant reports (signature status may change)
 */
export const useSendTenantSignature = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: FormData) => sendTenantSignature(formData),
    onSuccess: () => {
      toast.success("Firma enviada exitosamente");
      // Invalidate tenant reports as signature status may have changed
      queryClient.invalidateQueries({ queryKey: queryKeys.tenantReports.all });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message || "Error al enviar la firma";
      toast.error(errorMessage);
    },
  });
};
